<div>
  <div class="bg-white shadow-sm-light">

    <div class="tabs-admis px-3">
      <div class="mb-4 border-b border-white dark:border-gray-700">
        <ul class="justify-center flex flex-wrap -mb-px text-sm text-gray-700 font-medium text-center" id="default-tab"
          data-tabs-toggle="#default-tab-content" role="tablist">
          <li class="me-2" role="presentation">
            <button
              class="focus:outline-none hover:bg-gray-800 focus:ring-4 focus:ring-gray-300 w-fit text-white mat-mdc-input-element bg-gray-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-red-700 dark:focus:ring-red-900"
              [routerLink]="['/dashboard/appels/sigui/candidatures']"
              [attr.aria-selected]="activeTab === 'candidatures' ? true : false" type="button" role="tab"
              aria-controls="candidatures">
              Candidatures
            </button>
          </li>
          <li class="me-2" role="presentation">
            <button
              class="focus:outline-none hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 w-fit text-white mat-mdc-input-element bg-blue-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-blue-700 dark:focus:ring-blue-900"
              [ngClass]="{ 'tab-selected': activeTab === 'deliberation' }"
              [routerLink]="['/dashboard/appels/sigui/deliberation']"
              [attr.aria-selected]="activeTab === 'deliberation' ? true : false" type="button" role="tab"
              aria-controls="deliberation">
              Déliberation
            </button>
          </li>
          <li class="me-2" role="presentation">
            <button
              class="focus:outline-none hover:bg-green-800 bg-green-500 focus:ring-4 focus:ring-green-300 w-fit text-white mat-mdc-input-element inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-green-700 dark:focus:ring-green-900"
              [ngClass]="{ 'tab-selected': activeTab === 'admis' }" [routerLink]="['/dashboard/appels/sigui/admis']"
              [attr.aria-selected]="activeTab === 'admis' ? true : false" type="button" role="tab"
              aria-controls="admis">
              Liste des admis
            </button>
          </li>
          <li class="me-2" role="presentation">
            <button
              class="focus:outline-none hover:bg-red-800 focus:ring-4 focus:ring-red-300 w-fit text-white mat-mdc-input-element bg-red-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-red-700 dark:focus:ring-red-900"
              [ngClass]="{ 'tab-selected': activeTab === 'nonadmis' }"
              [routerLink]="['/dashboard/appels/sigui/nonadmis']"
              [attr.aria-selected]="activeTab === 'nonadmis' ? true : false" type="button" role="tab"
              aria-controls="nonadmis">
              Liste non admis
            </button>
          </li>
          <li class="me-2" role="presentation">
            <button
              class="focus:outline-none hover:bg-red-800 focus:ring-4 focus:ring-red-300 w-fit text-white mat-mdc-input-element bg-red-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-red-700 dark:focus:ring-red-900"
              [ngClass]="{ 'tab-selected': activeTab === 'Statistiques' }"
              [routerLink]="['/dashboard/appels/sigui/Statistiques']"
              [attr.aria-selected]="activeTab === 'Statistiques' ? true : false" type="button" role="tab"
              aria-controls="Statistiques">
              Statistiques...
            </button>
          </li>
        </ul>
      </div>
      <!-- <div id="default-tab-content">
        <div
          [ngClass]="{ hidden: activeTab !== 'candidatures' }"
          class="p-4 rounded-lg bg-white dark:bg-gray-800"
          id="candidatures"
          role="tabpanel"
          aria-labelledby="candidatures-tab"
        >
          <app-sigui-appels></app-sigui-appels>
        </div>
        <div
          [ngClass]="{ hidden: activeTab !== 'deliberation' }"
          class="p-4 rounded-lg bg-white dark:bg-gray-800"
          id="deliberation"
          role="tabpanel"
          aria-labelledby="deliberation-tab"
        >
          <app-deliberation></app-deliberation>
        </div>
        <div
          [ngClass]="{ hidden: activeTab !== 'admis' }"
          class="p-4 rounded-lg bg-white dark:bg-gray-800"
          id="admis"
          role="tabpanel"
          aria-labelledby="admis-tab"
        >
          <app-admis></app-admis>
        </div>
        <div
          [ngClass]="{ hidden: activeTab !== 'nonadmis' }"
          class="p-4 rounded-lg bg-white dark:bg-gray-800"
          id="nonadmis"
          role="tabpanel"
          aria-labelledby="nonadmis-tab"
        >
          <app-nonadmis></app-nonadmis>
        </div>
        <div
          [ngClass]="{ hidden: activeTab !== 'Statistiques' }"
          class="p-4 rounded-lg bg-white dark:bg-gray-800"
          id="Statistiques"
          role="tabpanel"
          aria-labelledby="Statistiques-tab"
        >
          <app-statistics></app-statistics>
        </div>
      </div> -->
    </div>
  </div>
</div>